module.exports = "/_next/static/images/Security-md@2x-ba0a1b27535936a22ca984c6484b1d8b.png";